export interface FormHeader {
  PIR: string;
}
export const defaultFormHeader: FormHeader = {
  PIR: "",
};
